import { render, staticRenderFns } from "./MemberUpgrade.vue?vue&type=template&id=a855074c&"
import script from "./MemberUpgrade.vue?vue&type=script&lang=js&"
export * from "./MemberUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./MemberUpgrade.vue?vue&type=style&index=0&id=a855074c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports